/* This wrapper around GA. Ideally swapping out GA for another analytics tool
   would mean only adjusting this module. */
import ReactGA from 'react-ga4'

export const analyticsId = process.env.REACT_APP_ANALYTICS_ID

export function initialize() {
  if (analyticsId) {
    ReactGA.initialize(analyticsId)
  }
}

export function recordModalView(view: string) {
  if (analyticsId) {
    ReactGA.send({ hitType: 'pageview', page: view })
  }
}

export function recordEvent(
  category: string,
  action: string,
  extra?: any // tslint:disable-line
) {
  if (analyticsId) {
    ReactGA.event({
      category,
      action,
      ...extra
    })
  }
}

export function recordException(description: string, fatal: boolean = false) {
  recordEvent('exception', description, fatal)
}



// WEBPACK FOOTER //
// ./src/analytics/index.ts